<template>
	<div
		class="leaderboard-first"
		:class="{ wall, text }"
		@click="onClick"
		@mousedown="onDown"
	>
		<div class="leaderboard-first__crown">
			<img src="@/assets/crown.svg" alt="First place" />
		</div>
		<div
			v-if="submission.thumbnail"
			class="leaderboard-first__thumbnail"
			:style="submission.thumbnail"
		></div>
		<div class="leaderboard-first__details">
			<div class="leaderboard-first__title">{{ submission.title }}</div>
			<div class="leaderboard-first__subtitle">by {{ name }}</div>
			<div class="leaderboard-first__likes">
				{{ submission.likes | number }} {{ likes }}
			</div>
		</div>
	</div>
</template>

<script>
import { enums } from 'protoswipe-shared'

export default {
	name: 'LeaderboardFirst',
	props: {
		submission: Object,
		wall: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		text() {
			return this.submission.campaign.type === enums.CampaignType.text
		},
		name() {
			return this.submission.nickname || 'Anonymous'
		},
		likes() {
			return this.submission.likes === 1 ? 'like' : 'likes'
		}
	},
	methods: {
		onClick() {
			if (!this.wall) this.open()
		},
		onDown() {
			if (this.wall) this.open()
		},
		open() {
			this.$emit('select', this.submission.id)
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/layout';
@import '~scss/components';
@import '~scss/mq';

$br: 0.25rem;
$gap: 0.5rem;

.leaderboard-first {
	@extend %flex-row;
	position: relative;
	background-color: $white;
	border-radius: $br;
	margin: 2rem auto $gap;
	padding: 0.5rem;
	cursor: pointer;

	&__crown {
		position: absolute;
		top: -2.4rem;
		left: -1.3rem;
		width: 3rem;
		height: 3rem;
		font-size: 1.5rem;
		font-weight: bold;
		color: $white;
	}

	&__thumbnail {
		@include thumbnail(6rem);
		flex-shrink: 0;
		margin-right: 0.5rem;
	}

	&__details {
		@extend %flex-col;
		align-items: center;
		text-align: center;
		flex-grow: 1;
		padding: 0.5rem;
	}

	&__title {
		font-size: 1.125rem;
		font-weight: bold;
	}

	&__subtitle {
		@extend %nowrap;
	}

	&__likes {
		margin-top: 0.75rem;
	}

	// Modifiers

	&.wall:hover {
		background-color: $blue-48;
		color: $white;
	}

	&.text &__title {
		@extend %quote;
	}

	// Media queries

	@include mq(xs) {
		&__thumbnail {
			@include thumbnail(7.5rem);
		}
	}

	@include mq(md) {
		&:not(.wall) &__crown {
			top: -3.2rem;
			left: -1.8rem;
			width: 4rem;
			height: 4rem;
		}
		&__thumbnail {
			@include thumbnail(9rem);
		}
		&__title {
			font-size: 1.5rem;
		}
		&__likes {
			font-size: 1.25rem;
		}
	}
}
</style>
